import { RootState } from "@client/redux/types";
import { NAMESPACE } from "./constants";

export const getMylounge = (state: RootState) => state[NAMESPACE];

export const getOpenCampaigns = (state: RootState) => state[NAMESPACE].openCampaigns;

export const getUpcomingCampaigns = (state: RootState) => state[NAMESPACE].upcomingCampaigns;

export const getTabs = (state: RootState) => state[NAMESPACE].tabs;

export const getIsLoading = (state: RootState) => state[NAMESPACE].loading;

export const getError = (state: RootState) => state[NAMESPACE].error;

export const getImagesLoaded = (state: RootState) => state[NAMESPACE].imagesLoaded;
